// removed by extract-text-webpack-plugin
module.exports = {"Certi":"Certi__Certi__3ZqOx","Cbutton":"Certi__Cbutton__2k-CD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Experience/Certi/Certi.css
// module id = 146
// module chunks = 0